import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import FaqSection from './components/FaqSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import MediaSection from './components/MediaSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="relative bg-background-50">
      <Header />
      <Hero />
      <AppSection />
      <CardsSection />
      <FaqSection />
      <RankingSection />
      <TopicsSection />
      <CommentsSection />
      <ContactSection />
      <FeaturesSection />
      <UpdatesSection />
      <MediaSection />
      <IndexSection />
      <AboutSection />
      <CarouselSection />
      <Footer />
    </main>
  );
}